import * as React from 'react'
import styled, { keyframes } from 'styled-components'
import { I18nService } from '../../services/utils/i18n.service'

const i18nScoped = new I18nService(require('./floating-bottom-panel.component.yml'))

const enterFromBottom = keyframes`
  0% { transform: translateY(100%) }
  100% { transform: translateY(0%) }
`

const FloatingBottomBottomPanel = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  animation: ${ enterFromBottom }  .5s ease-out forwards;

  @media (min-width: 60em) {
    left: calc(50% - 26em);
    right: unset;
    width: 52em;
  }
`

const FloatingBottomPanelContent = styled.div`
  color: white;
  background-color: ${ props => props.theme.colors.clr_0_dark };
  border-top-left-radius: 0.5em;
  border-top-right-radius: 0.5em;
  max-height: 80vh;
  overflow: auto;
`

const CloseLink = styled.a`
  color: white !important;
  text-align: right;
  display: block;
  margin: 0.5em;
`

export const FloatingBottomPanelRow = styled.div`
  display: flex;
  background-color: #FFFFFF25;
  border-radius: 0.5em;
  padding: 1em;
  margin: 0.5em;
  justify-content: space-between;
  align-items: center;

  a {
    color: white;
  }
`

export const FLoatingButtonPanelTitle = styled.h4`
  margin: 1em !important;
  color: white !important;
`

interface Props {
  onCancel: () => void
  children?: React.ReactNode
}

/**
 * Global variable storing generated CSS ids other panels being opened, allowing to hide them
 * for the time a new one is in front (allowing clean UI with nested bottom panels).
 */
const allrPanelIds = { current: [] as string[] }

export function FloatingBottomPanelComponent ({ onCancel, children }: Props) {
  const [cssId, setCssId] = React.useState<string>()

  React.useEffect(() => {
    const id = `floating-bottom-panel-${ Math.random().toString(36).substring(2) }`
    allrPanelIds.current.push(id)
    setCssId(id)

    return () => { allrPanelIds.current = allrPanelIds.current.filter(_ => _ !== id) }
  }, [])

  return <div className="jquery-modal blocker" onClick={ evt => evt.target === evt.currentTarget && onCancel() } id={ cssId }>
    <style>{ `${allrPanelIds.current.filter(_ => _ != cssId).map(_ => '#' + _).join(', ')} { display: none !important; }` }</style>

    <FloatingBottomBottomPanel>
      <CloseLink onClick={ onCancel }><em className="icon-close u-mrs" /> { i18nScoped.t('close') }</CloseLink>

      <FloatingBottomPanelContent children={ children } />
    </FloatingBottomBottomPanel>
  </div>
}
